import { EarnsSummary } from '@com-delta-idp/mnx-skymiles-overview-ui';
import {
  AEMErrorMessage,
  checkErrors,
  getEmptyContent,
  isDisplay,
  isError,
  isValidData
} from '@com-delta-idp/mnx-skymiles-shared';
import { logError } from '@com-delta-idp/mnx-utils';
import { MqdSummary } from '../models/api/content-api.interfaces';
import { EarnsSummaryResponse } from '../models/api/earns-summary.interfaces';
import { getActionDetail } from '../utils/earns-summary-extended.utils';
import { getActivities } from '../utils/earns-summary-helper.utils';
import { getToggleValues } from '../utils/earns-summary.utils';
import { getFooterDetails } from '../utils/mqd-summary.utils';

export const getEarnsSummary = (
  aem: MqdSummary | undefined,
  activities: EarnsSummaryResponse | undefined,
  countryCode: string | undefined,
  featureFlag: boolean | undefined,
  errors: (string | undefined)[],
  aemErrorMessages: AEMErrorMessage[] | undefined
): EarnsSummary => {
  try {
    if (checkErrors(errors, aemErrorMessages)) {
      return isError<EarnsSummary>(
        'earns-summary',
        aemErrorMessages as AEMErrorMessage[],
        featureFlag
      );
    }
    return isValidData<
      MqdSummary,
      [
        MqdSummary | undefined,
        EarnsSummaryResponse | undefined,
        boolean | undefined
      ]
    >('title', aem, activities, featureFlag)
      ? adaptEarnsSummaryObject(
          aem as MqdSummary,
          activities as EarnsSummaryResponse,
          countryCode as string,
          featureFlag as boolean
        )
      : isDisplay<EarnsSummary>(featureFlag);
  } catch (error) {
    logError(error as Error, 'SKYMILES', 'OVERVIEW', 'EARNS_SUMMARY');
    return getEmptyContent<EarnsSummary>(
      'earns-summary',
      aemErrorMessages,
      true
    );
  }
};

export const adaptEarnsSummaryObject = (
  aem: MqdSummary,
  activities: EarnsSummaryResponse,
  countryCode: string,
  featureFlag: boolean
): EarnsSummary => {
  if (activities.currentYearDashboard?.length > 0 && featureFlag) {
    return {
      title: aem.title,
      toggle: getToggleValues(aem),
      activities: getActivities(aem, activities, countryCode),
      action: getActionDetail(aem.linkLabel, aem.linkUrl, aem.linkId),
      summary: getFooterDetails(aem.noteLabel, aem.noteToolTipInfo),
      disabled: !featureFlag,
      loaded: true,
      ariaLabels: { action: aem.linkLabel }
    };
  } else {
    return getEmptyContent<EarnsSummary>('', [], true, true);
  }
};
